import React from 'react'
import { Typography, Grid, LinearProgress, Card } from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/styles';

import CardComp from './Components/CardComp/CardComp';
import CardCompChildModel from './Components/CardCompChildModel/CardCompChildModel';

import RecentOrders from './Components/RecentOrders/RecentOrders'

// import Dounghnut from './Components/Charts/Dounghnut'
import PolarChart from './Components/Charts/PolarChart'
// import RandomizedLine from './Components/Charts/RandomizedLine'
import RandomizedLineYear from './Components/Charts/RandomizedLineYear'

import TabsComp from './Components/TabsComp/TabsComp'

import RenderLineChart from './Components/ReCharts/LineChart'
import TinyAreaChart from './Components/ReCharts/TinyAreaChart'
import TinyLineChart from './Components/ReCharts/TinyLineChart'
import TinyBarChart from './Components/ReCharts/TinyBarChart'


import MonetizationOnIcon from '@material-ui/icons/MonetizationOn';
import GroupAddIcon from '@material-ui/icons/GroupAdd';
import WorkOutlineRoundedIcon from '@material-ui/icons/WorkOutlineRounded';
import LocalAtmRoundedIcon from '@material-ui/icons/LocalAtmRounded';
import clsx from 'clsx';


const useStyles = makeStyles(theme => ({

    root: {
        display: 'flex',
        flexDirection: 'column',
        flex: 1
    },
    gridContainerOuter: {
        margin: '6px -6px',
        display: 'flex',
        justifyContent: 'center'
    },
    gridItemInner: {
        padding: '3px 6px',
        width: '100%'
        // [theme.breakpoints.down('md')]: {
        //     paddingTop: 6,
        //     paddingBottom: 6
        // } 
    },
    avatarIcon: {
        width: 38,
        height: 38
    },
    progress: {
        marginTop: 18,
        width: '100%',
        height: 6,
        borderRadius: 6
    },
    titleDiv: {
        padding: '8px 0px 12px 0px'
    },
    divTopSpace: {
        marginTop: theme.spacing(3),
    },
    profileBoxDiv: {
        display: 'flex',
        flexDirection: 'column',
        [theme.breakpoints.down('md')]: {
            height: 400
        }
    },
    tinyCharts: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        margin: '-3px 0px'
    },
    tinyCards: {
        flex: 1,
        margin: '3px 0px',
        display: 'flex',
        justifyContent: 'center',
    },
    infoText: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        padding: '0px 10px',
        marginLeft: 10
    },
    graph: {
        flex: 1,
        overflow: 'hidden'
    },
    cardLinechart: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%'
    },
    randomize: {
        display: 'flex',
        height: '100%',
        justifyContent: 'center',
        alignItems: 'center',
        overflowX: 'hidden',
    }
}));

function Dashboard(props) {
    const { className, ...rest } = props
    const classes = useStyles();
    const theme = useTheme();
    return (
        <div className={classes.root}>


            <div className={classes.titleDiv}>
                <Typography variant="h2">Dashboard</Typography>
            </div>

            <Grid container className={classes.gridContainerOuter}>
                <Grid item xs={12} sm={6} md={3} className={classes.gridItemInner}>
                    <CardComp
                        title="Budget"
                        value="$55,000"
                        percentage="24%"
                        since="Since Last Month"
                        iconMain={<MonetizationOnIcon className={classes.avatarIcon} />}
                        avatarColor={theme.palette.primary.main}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={3} className={classes.gridItemInner}>
                    <CardComp
                        title="New Clients"
                        value="100"
                        percentage="10%"
                        since="in Last Month"
                        iconMain={<GroupAddIcon className={classes.avatarIcon} />}
                        //iconMain =  {<GroupAddIcon classes={{ label: 'avatarIcon' }} />}
                        avatarColor={theme.palette.info.dark}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={3} className={classes.gridItemInner}>
                    <CardCompChildModel
                        title="Work Progress"
                        value="80%"
                        iconMain={<WorkOutlineRoundedIcon className={classes.avatarIcon} />}
                        avatarColor={theme.palette.success.main}
                    >
                        <LinearProgress value={80} variant="determinate" color="primary" className={classes.progress}></LinearProgress>
                    </ CardCompChildModel>
                </Grid>
                <Grid item xs={12} sm={6} md={3} className={classes.gridItemInner}>
                    <CardCompChildModel
                        title="Profits"
                        value="$45,000"
                        iconMain={<LocalAtmRoundedIcon className={classes.avatarIcon} />}
                        avatarColor={theme.palette.warning.main}
                    >
                        <LinearProgress value={10} variant="determinate" color="primary" className={classes.progress}></LinearProgress>

                    </ CardCompChildModel>
                </Grid>
            </Grid>


            <Grid container className={classes.gridContainerOuter}>
                <Grid item xs={12} sm={12} md={8} className={classes.gridItemInner}>
                    <Card className={classes.randomize}>
                        <RandomizedLineYear />
                    </Card>
                </Grid>
                <Grid item xs={12} sm={12} md={4} className={classes.gridItemInner}>
                    <TabsComp />
                </Grid>
            </Grid>


            <Grid container className={classes.gridContainerOuter}>
                <Grid item sm={12} md={8} className={classes.gridItemInner}>
                    <RecentOrders />
                </Grid>

                <Grid item sm={12} md={4} align="center"
                    className={clsx(classes.gridItemInner,
                        classes.profileBoxDiv)}>


                    <div className={classes.tinyCharts}>
                        <Card className={classes.tinyCards}>
                            <div className={classes.infoText} >
                                <Typography variant="h3"> $55,000</Typography>
                                <Typography variant="h5" color="textPrimary">Total income</Typography>
                            </div>
                            <div className={classes.graph}>
                                <TinyAreaChart />
                            </div>
                        </Card>
                        <Card className={classes.tinyCards}>
                            <div className={classes.infoText} >
                                <Typography variant="h3">240</Typography>
                                <Typography variant="h5" color="textPrimary">Queries</Typography>
                            </div>

                            <div className={classes.graph}>
                                <TinyLineChart />
                            </div>
                        </Card>
                        <Card className={classes.tinyCards}>
                            <div className={classes.infoText} >
                                <Typography variant="h3">12,000</Typography>
                                <Typography variant="h5" color="textPrimary">Visitors</Typography>
                            </div>

                            <div className={classes.graph}>
                                <TinyBarChart />
                            </div>
                        </Card>
                    </div>

                </Grid>
            </Grid>

            <Grid container className={classes.gridContainerOuter}>
                <Grid item sm={12} md={6} className={classes.gridItemInner}>
                    <Card className={classes.cardLinechart}>
                        <RenderLineChart />
                    </Card>
                </Grid>
                <Grid item sm={12} md={6} className={classes.gridItemInner}>
                    <Card className={classes.cardLinechart}>
                        <PolarChart />
                    </Card>
                </Grid>
            </Grid>
        </div>
    )
}

export default Dashboard
